"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    map: {
        en: "Map",
        es: "Mapa",
    },
    user: {
        en: "User",
        es: "Usuario",
    },
    maintenance: {
        en: "Maintenance",
        es: "Mantenimiento",
    },
    devices: {
        en: "Units",
        es: "Unidades",
    },
    digitalInput: {
        en: "Digital Inputs",
        es: "Entradas Digitales",
    },
    listOfDigitalInputs: {
        en: "List of Digitals Inputs",
        es: "Lista de Entradas Digitales",
    },
    address: {
        en: "Address",
        es: "Dirección",
    },
    simDataUsage: {
        en: "Data Usage",
        es: "Uso de Datos",
    },
    speed: {
        en: "Speed",
        es: "Velocidad",
    },
    speedatRPM: {
        en: "{speed} at {rpm}",
        es: "{speed} a {rpm}",
    },
    temperature: {
        en: "Temperature",
        es: "Temperatura",
    },
    or: {
        en: "Or",
        es: "O",
    },
    camera: {
        en: "Camera",
        es: "Cámara",
    },
    videoCamera: {
        en: "Video camera",
        es: "Cámara de video",
    },
    comment: {
        en: "Comment",
        es: "Comentario",
    },
    table: {
        en: "Table",
        es: "Tabla",
    },
    infoNotAvailable: {
        en: "Information not available",
        es: "Información no disponible",
    },
    list: {
        en: "List",
        es: "Lista",
    },
    timeLine: {
        en: "Time Line",
        es: "Linea Cronologica",
    },
    tableTotalSession: {
        en: "Total of {name, plural, =0 {no Sessions} one {# Session}other {# Sessions}}.",
        es: "Total de {name, plural, =0 {No tiene} one {# Sesion}other {# Sesiones}}.",
    },
    deleteZero: {
        en: "You didn't select any row.",
        es: "No se selecciono ninguna fila.",
    },
    unitStatus: {
        en: "Current State",
        es: "Estado Actual",
    },
    sukarneTrips: {
        en: "Sukarne trips",
        es: "Viajes Sukarne",
    },
    startsAt: {
        en: "Starts at",
        es: "Empieza el",
    },
    endsAt: {
        en: "Ends at",
        es: "Finaliza el",
    },
    pending: {
        en: "Pending",
        es: "Pendiente",
    },
    inProgress: {
        en: "In progress",
        es: "En curso",
    },
    completed: {
        en: "Completed",
        es: "Finalizado",
    },
    inCompleted: {
        en: "Incompleted",
        es: "Sin Finalizar",
    },
    trip: {
        en: "Trip",
        es: "Viaje",
    },
    origin: {
        en: "Origin",
        es: "Origen",
    },
    destination: {
        en: "Destination",
        es: "Destino",
    },
    eventsTimeline: {
        en: "Events Timeline",
        es: "Cronología de Eventos",
    },
    geofenceTimeline: {
        en: "Geofence timeline",
        es: "Cronología de geocerca",
    },
    eventDetails: {
        en: "Events Detail",
        es: "Eventos Detalle",
    },
    eventGeofence: {
        en: "Geofence Events",
        es: "Geocerca Eventos",
    },
    unitStatusDetail: {
        en: "Current State Detail",
        es: "Estado Actual Detalle",
    },
    preventiveMaintenance: {
        en: "Scheduled Maintenance",
        es: "Mantenimiento Preventivo",
    },
    speedTop5: {
        en: "Speed Top 5",
        es: "Velocidad Max 5",
    },
    batteryLevel: {
        en: "Battery Level",
        es: "Batería",
    },
    editDashboard: {
        en: "Edit Dashboard",
        es: "Editar Tablero",
    },
    noChartData: {
        en: "No data",
        es: "No hay datos",
    },
    yes: {
        en: "Yes",
        es: "Si",
    },
    no: {
        en: "No",
        es: "No",
    },
    add: {
        en: "Add",
        es: "Agregar",
    },
    allEvents: {
        en: "All Events",
        es: "Todos los Eventos",
    },
    previewLoadError: {
        en: "Could not load file preview.",
        es: "No se pudo cargar la vista previa del archivo.",
    },
    maxFilesSelectedError: {
        en: "Exceeded file quantity (max: {quantity})",
        es: "Cantidad de archivos excedida (máximo: {quantity})",
    },
    dragAdd: {
        en: "Click here or drag files to this area to upload",
        es: "Haga clic aquí o arrastre archivos a esta área para subir",
    },
    LOGIN_SUCCESS: {
        en: "{name} logged in.",
        es: "{name} inició sesión.",
    },
    LOGIN_FAILED: {
        en: "{name} failed to log in.",
        es: "{name} tuvo un error al iniciar sesión.",
    },
    LOGOUT_SUCCESS: {
        en: "{name} logged out.",
        es: "{name} se desconectó.",
    },
    LOGOUT_FAILED: {
        en: "{name} failed to log out.",
        es: "{name} tuvo un error al desconectarse.",
    },
    IMPERSONATE_SUCCESS: {
        en: "{impersonator} impersonated {impersonated}.",
        es: "{impersonator} impersonó a {impersonated}.",
    },
    IMPERSONATE_FAILED: {
        en: "{impersonator} failed to impersonate {impersonated}.",
        es: "{impersonator} tuvo un error al intentar impersonar a {impersonated}.",
    },
    REVERT_IMPERSONATE_SUCCESS: {
        en: "{impersonator} reverted impersonate from {impersonated}.",
        es: "{impersonator} revirtió impersonar a {impersonated}.",
    },
    REVERT_IMPERSONATE_FAILED: {
        en: "{impersonator} failed to revert impersonate from {impersonated}.",
        es: "{impersonator} tuvo un error al intentar revertir impersonar a {impersonated}.",
    },
    temperatureEvent: {
        en: "Temperature Sensor",
        es: "Sensor de Temperatura",
    },
    temperatureThermometerConfig: {
        en: "Thermometers configuration ",
        es: "Configuración de termómetros",
    },
    fuelSensors: {
        en: "Fuel Sensors",
        es: "Sensor de Combustible",
    },
    configuration: {
        en: "Configuration",
        es: "Configuracion",
    },
    configurations: {
        en: "Configurations",
        es: "Configuraciónes",
    },
    idle: {
        en: "Idle",
        es: "Estacionado con motor encendido",
    },
    parameters: {
        en: "Parameters",
        es: "Parametros",
    },
    report: {
        en: "Report",
        es: "Reporte",
    },
    every: {
        en: "Every",
        es: "Cada",
    },
    month: {
        en: "Month",
        es: "Mes",
    },
    week: {
        en: "Week",
        es: "Semana",
    },
    day: {
        en: "Day",
        es: "Día",
    },
    months: {
        en: "Months",
        es: "Meses",
    },
    weeks: {
        en: "Weeks",
        es: "Semanas",
    },
    days: {
        en: "Days",
        es: "Días",
    },
    dataUsed: {
        en: "Data Used",
        es: "Datos Utilizados",
    },
    dataLimit: {
        en: "Data Limit",
        es: "Límite de datos",
    },
    billingCycleRemainingDays: {
        en: " to reset monthly data package.",
        es: " para reinicio de paquete de datos mensual.",
    },
    billingcycle: {
        en: "Billing cycle",
        es: "Ciclo de facturación",
    },
    traceSegmentation: {
        en: "Trace segmentation",
        es: "Segmentación de rastro",
    },
    thermometer: {
        en: "Thermometer",
        es: "Termómetro",
    },
    updatedOn: {
        en: "Updated on",
        es: "Actualizado el ",
    },
    notProcessed: {
        en: "Not processed",
        es: "Sin procesar",
    },
    onQueue: {
        en: "On queue",
        es: "En cola",
    },
    generated: {
        en: "Generated",
        es: "Generado",
    },
    home: {
        en: "Home",
        es: "Inicio",
    },
    fail: {
        en: "Fail",
        es: "Falló",
    },
    createdOn: {
        en: "Created on",
        es: "Creado en ",
    },
    recurrence: {
        en: "Recurrence",
        es: "Recurrencia",
    },
    sendTo: {
        en: "Send to",
        es: "Enviar a",
    },
    batteryVoltage: {
        en: "Battery voltage",
        es: "Voltage de bateria",
    },
    remindOfMaintenance: {
        en: "Remind of maintenance",
        es: "Recordatorio de mantenimiento",
    },
    accumulatedHours: {
        en: "Accumulated hours",
        es: "Horas acumuladas",
    },
    distanceDriven: {
        en: "Distance driven",
        es: "Distancia conducida",
    },
    startCountOn: {
        en: "Start count since",
        es: "Contar desde",
    },
    restartCountOn: {
        en: "Restart count since",
        es: "Reiniciar conteo desde",
    },
    shipmentConfiguration: {
        en: "Shipment configuration",
        es: "Configuracion de envio",
    },
    expectedEfficiency: {
        en: "Expected efficiency",
        es: "Efficiencia esperada",
    },
    nextShipment: {
        en: "Next Shipment",
        es: "Próximo envío",
    },
    gallons: {
        en: "Gallons",
        es: "Galones",
    },
    liters: {
        en: "Liters",
        es: "Litros",
    },
    reading: {
        en: "Reading",
        es: "Lectura",
    },
    interpolation: {
        en: "Interpolation",
        es: "Interpolación",
    },
    reportType: {
        en: "Report type",
        es: "Tipo de reporte",
    },
    accountAlert: {
        en: "Event by user",
        es: "Evento por usuario",
    },
    hourly: {
        en: "Hourly",
        es: "Hourly",
    },
    daily: {
        en: "Daily",
        es: "Diario",
    },
    line: {
        en: "Line",
        es: "Linea",
    },
    point: {
        en: "Point",
        es: "Punto",
    },
    weekly: {
        en: "Weekly",
        es: "Semanal",
    },
    biWeekly: {
        en: "Biweekly",
        es: "Quincenal",
    },
    monthly: {
        en: "Monthly",
        es: "Mensual",
    },
    options: {
        en: "Options",
        es: "Opciónes",
    },
    limit: {
        en: "Limit",
        es: "Limite",
    },
    retry: {
        en: "Retry",
        es: "Reintentar",
    },
    liveCamera: {
        en: "LIVE",
        es: "EN VIVO",
    },
    rectangular: {
        en: "Rectangular",
        es: "Rectangular",
    },
    irregular: {
        en: "Irregular",
        es: "Irregular",
    },
    percentage: {
        en: "Percentage",
        es: "Porcentaje",
    },
    cylindrical: {
        en: "Cylindrical",
        es: "Cilindrico",
    },
    bill: {
        en: "Bill",
        es: "Factura",
    },
    createdBy: {
        en: "Created by",
        es: "Creado por",
    },
    dateRequested: {
        en: "Invoice date",
        es: "Fecha de la factura",
    },
    gasStations: {
        en: "Gas Stations",
        es: "Gasolineras",
    },
    requesters: {
        en: "Requesters",
        es: "Solicitantes",
    },
    devicesByCompany: {
        en: "Devices by Company",
        es: "Unidades por Compañía",
    },
    commandForCustomerSupport: {
        en: "Command for customer support",
        es: "Comando para servicio al cliente",
    },
    request: {
        en: "Request",
        es: "Solicitud",
    },
    response: {
        en: "Response",
        es: "Respuesta",
    },
    responseSatuts: {
        en: "Response Status",
        es: "Estado de Respuesta",
    },
    credentials: {
        en: "Credentials",
        es: "Credenciales",
    },
    viewData: {
        en: "View Data",
        es: "Ver Datos",
    },
    photo: {
        en: "Photo",
        es: "Foto",
    },
    video: {
        en: "Video",
        es: "Video",
    },
    initialDate: {
        en: "Initial date",
        es: "Fecha inicial",
    },
    endingDate: {
        en: "End Date",
        es: "Fecha Final",
    },
    automaticCommand: {
        en: "Automatic Commands",
        es: "Comandos Automáticos",
    },
    manageDevices: {
        en: "Manage Units",
        es: "Administrar Unidades",
    },
    scheduler: {
        en: "Scheduler.",
        es: "Planificador.",
    },
    unSubscribeFromAlerts: {
        en: "You want to stop receiving alerts in your email?",
        es: "¿Desea dejar de recibir alertas en su correo electrónico?",
    },
    kilometers: {
        en: "Kilometers",
        es: "Kilómetros",
    },
    miles: {
        en: "Miles",
        es: "Millas",
    },
    taskScheduler: {
        en: "Tasks Planner",
        es: "Planificador de tareas",
    },
    efficiencyMessage: {
        en: "You will be notified when the efficiency is less than",
        es: "Se alertará cuando la eficiencia sea menor a",
    },
    irregularConsumptionMessage: {
        en: "You will be notify when the fuel consumption exceeds ",
        es: "Se alertará cuando el nivel de combustible consumido sea mayor a",
    },
    fillingMessage: {
        en: "You will be notify when the fuel fill-up exceeds ",
        es: "Se alertará cuando el nivel de combustible ingresado sea mayor a",
    },
    todo: {
        en: "Assigned",
        es: "Asignadas",
    },
    skippedTask: {
        en: "Skipped",
        es: "Omitida",
    },
    filter: {
        en: "Filter",
        es: "Filtro",
    },
    effective: {
        en: "Effective",
        es: "Efectivo",
    },
    manageSubscriptions: {
        en: "Manage Subscriptions",
        es: "Administrar Suscripciones"
    },
    select: {
        en: "Select",
        es: "Seleccionar",
    },
    calendar: {
        en: "Calendar",
        es: "Calendario",
    }
};
exports.default = translations;
